// extracted by mini-css-extract-plugin
export default {"wrapper":"M_ContextMenu_wrapper__lB1IH"};